import { ERROR_DIALOG_DECLARATIONS } from './error-dialog';

export const DIALOGS_DECLARATIONS = [ERROR_DIALOG_DECLARATIONS];

export * from './error-dialog';
